export default __webpack_public_path__ + "static/media/LF-2.bed0754a.png";